export default __webpack_public_path__ + "static/events-light-a6f3857f2f9406ec374af86c378b6aff.png";